import React from "react";
import styled from "styled-components";
import PageStatus from "components/ui/PageStatus";
import { SignOutButton } from "components/ui/SignOutButton";
import {
  BaseButtonStyles,
  BlueButtonStyles,
  ModernBlueButtonStyles,
} from "components/ui/BaseButtonStyles";

import { StatusCard, StatusTitle, StatusBody } from "components/ui/StatusCard";

export function UIDSlateErrorCard() {
  return (
    <PageStatus>
      <StatusCard>
        <StatusTitle>
          <h2>Login Instructions</h2>
        </StatusTitle>
        <StatusBody>
          <p style={{ marginTop: 0 }}>
            You must now use your CalNet ID to log into CalCentral. Your
            MAP@Berkeley lD can no longer be used to log into CalCentral.
          </p>
          <p>
            Need help with your CalNet account? Visit{" "}
            <a href=" http://mycalnet.berkeley.edu/">mycalnet.berkeley.edu</a>.
          </p>
          <p>
            Use your MAP@Berkeley ID email and password if you wish to log into{" "}
            <a href=" http://mycalnet.berkeley.edu/">MAP@Berkeley</a>. For
            further assistance, visit{" "}
            <a href="https://sis.berkeley.edu/help/calcentral-support">
              support
            </a>
            .
          </p>
          <SignoutButtonWrapper>
            <SignOutButton label="Log in with CalNet ID" />
          </SignoutButtonWrapper>
        </StatusBody>
      </StatusCard>
    </PageStatus>
  );
}

const SignoutButtonWrapper = styled.div`
  button {
    ${BaseButtonStyles}
    ${BlueButtonStyles}
    ${ModernBlueButtonStyles}
    font-size: 18px;
  }
`;
